import {
    useEffect,
    useState
}
from "react";

import {
    functions
}
from "../../../constants/common-functions";


export default function useEva()
{

    //--------------------------------------------------------
    // State - Home
    //--------------------------------------------------------

    const [homeItems, setHomeItems] =
        useState([]);

    const [loading, setLoading] =
        useState(true);


    //--------------------------------------------------------
    // State - Directory
    //--------------------------------------------------------

    const [directory, setDirectory] =
        useState(null);

    const [directoryChildren, setDirectoryChildren] =
        useState([]);

    const [directoryDocuments, setDirectoryDocuments] =
        useState([]);

    const [directorySections, setDirectorySections] =
        useState([]);


    //--------------------------------------------------------
    // Loading - Directory
    //--------------------------------------------------------

    const [directoryLoading, setDirectoryLoading] =
        useState(false);

    const [childrenLoading, setChildrenLoading] =
        useState(false);

    const [documentsLoading, setDocumentsLoading] =
        useState(false);

    const [sectionsLoading, setSectionsLoading] =
        useState(false);


    //--------------------------------------------------------
    // Load home items
    //--------------------------------------------------------

    const loadHomeItems =
        () =>
        {
            setLoading(true);

            functions.getArrayFromAjax(

                "/resolutionsoftwareplatform/eva/home",

                (items) =>
                {
                    console.log(
                        "EVA HOME ITEMS:",
                        items
                    );

                    setHomeItems(
                        items
                    );
                },

                () =>
                {
                    setLoading(
                        false
                    );
                }

            );
        };


    //--------------------------------------------------------
    // Load directory info
    //--------------------------------------------------------

    const loadDirectoryInfo =
        (directoryId) =>
        {
            if (!directoryId)
            {
                return;
            }


            setDirectoryLoading(
                true
            );


            functions.getObjectFromAjax(

                "/resolutionsoftwareplatform/eva/directory/"
                + directoryId,

                (item) =>
                {
                    console.log(
                        "EVA DIRECTORY:",
                        item
                    );


                    setDirectory(
                        item
                    );
                },

                () =>
                {
                    setDirectoryLoading(
                        false
                    );
                }

            );
        };


    //--------------------------------------------------------
    // Load directory children
    //--------------------------------------------------------

    const loadDirectoryChildren =
        (directoryId) =>
        {
            if (!directoryId)
            {
                return;
            }


            setChildrenLoading(
                true
            );


            functions.getArrayFromAjax(

                "/resolutionsoftwareplatform/eva/directory/"
                + directoryId
                + "/children",

                (items) =>
                {
                    console.log(
                        "EVA DIRECTORY CHILDREN:",
                        items
                    );


                    setDirectoryChildren(
                        items
                    );
                },

                () =>
                {
                    setChildrenLoading(
                        false
                    );
                }

            );
        };


    //--------------------------------------------------------
    // Load directory documents
    //--------------------------------------------------------

    const loadDirectoryDocuments =
        (directoryId) =>
        {
            if (!directoryId)
            {
                return;
            }


            setDocumentsLoading(
                true
            );


            functions.getArrayFromAjax(

                "/resolutionsoftwareplatform/eva/directory/"
                + directoryId
                + "/documents",

                (items) =>
                {
                    console.log(
                        "EVA DIRECTORY DOCUMENTS:",
                        items
                    );


                    setDirectoryDocuments(
                        items
                    );
                },

                () =>
                {
                    setDocumentsLoading(
                        false
                    );
                }

            );
        };


    //--------------------------------------------------------
    // Load directory sections
    //--------------------------------------------------------

    const loadDirectorySections =
        (directoryId) =>
        {
            if (!directoryId)
            {
                return;
            }


            setSectionsLoading(
                true
            );


            functions.getArrayFromAjax(

                "/resolutionsoftwareplatform/eva/directory/"
                + directoryId
                + "/sections",

                (items) =>
                {
                    console.log(
                        "EVA DIRECTORY SECTIONS:",
                        items
                    );


                    setDirectorySections(
                        items
                    );
                },

                () =>
                {
                    setSectionsLoading(
                        false
                    );
                }

            );
        };


    //--------------------------------------------------------
    // Load complete directory
    //
    // All four requests start independently.
    //--------------------------------------------------------

    const loadDirectory =
        (directoryId) =>
        {
            if (!directoryId)
            {
                return;
            }


            //------------------------------------------------
            // Clear previous directory
            //------------------------------------------------

            setDirectory(
                null
            );

            setDirectoryChildren(
                []
            );

            setDirectoryDocuments(
                []
            );

            setDirectorySections(
                []
            );


            //------------------------------------------------
            // Fire all requests
            //------------------------------------------------

            loadDirectoryInfo(
                directoryId
            );

            loadDirectoryChildren(
                directoryId
            );

            loadDirectoryDocuments(
                directoryId
            );

            loadDirectorySections(
                directoryId
            );
        };


    //--------------------------------------------------------
    // Initial load
    //--------------------------------------------------------

    useEffect(

        () =>
        {
            loadHomeItems();
        },

        []

    );


    //--------------------------------------------------------
    // Return
    //--------------------------------------------------------

    return {

        //----------------------------------------------------
        // Home
        //----------------------------------------------------

        homeItems,
        loading,
        loadHomeItems,


        //----------------------------------------------------
        // Directory data
        //----------------------------------------------------

        directory,
        directoryChildren,
        directoryDocuments,
        directorySections,


        //----------------------------------------------------
        // Directory loading
        //----------------------------------------------------

        directoryLoading,
        childrenLoading,
        documentsLoading,
        sectionsLoading,


        //----------------------------------------------------
        // Directory functions
        //----------------------------------------------------

        loadDirectory,
        loadDirectoryInfo,
        loadDirectoryChildren,
        loadDirectoryDocuments,
        loadDirectorySections

    };

}